import api from "./axios";

export const getUserRequestList = async ({
  name_search_query = "",
  list_type = null,
  request_type = 1, // 1 = MESSAGE, 2 = CALL
  page = 1,
  limit = 20,
} = {}) => {
  const response = await api.get("/chat/user-request-list/", {
    params: {
      page,
      limit,
      name_search_query,
      request_type,
      list_type: Array.isArray(list_type)
        ? JSON.stringify(list_type)
        : list_type,
    },
  });

  return response.data;
};